import styled from '@emotion/styled';

import { ButtonSlim } from 'components/buttons';

export const FeedbackWrapper = styled.div`
  display: flex;
  font-size: 0.9rem;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 0.5rem;
  margin-top: 0.5rem;
`;

// General content display, gray background and rounded edges
export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #ededed;
  padding: ${({ padded }) => (padded ? '0.35rem' : '0')};
  margin-left: 0.4rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const EmojiSelector = styled(ContentWrapper)`
  width: ${({ multi }) => (multi ? '120px' : 'auto')};
  padding: 0;
  white-space: nowrap;
  justify-content: space-between;

  span {
    padding: 0.3rem 0 0.4rem;
    margin: 0;
  }

  span:first-child {
    padding-left: 0.35rem;
  }

  span:last-child {
    padding-right: 0.35rem;
  }
`;

export const RatingText = styled.span`
  line-height: 0.9rem;
`;

export const Form = styled.div`
  width: 100%;
  margin-bottom: 0.2rem;

  textarea {
    font-family: ${({ theme }) => theme.fonts.default};
    font-size: 1rem;
    width: 100%;
    height: 4rem;
    border-radius: 0.5rem;
    border-style: solid;
    padding: 0.35rem;
    resize: none;
  }
`;

export const SendButton = styled(ButtonSlim)`
  font-size: 0.9rem;
  min-width: auto;
  padding: 0 0.6rem;
  margin-left: 0.4rem;
`;

export const ThankYouMessage = styled.div`
  width: 100%;
  text-align: center;
  padding: 2rem;
`;
